export const VERTICAL_OFFSET_TABLE_VIEW = 18;

export const HORIZONTAL_OFFSET_TABLE_VIEW = -4;
